import Vue from 'vue'
import Router from 'vue-router'
import { TokenService } from './services/token.service'
import { RoleService } from './services/role.service'

Vue.use(Router)

let router =  new Router({
  //mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: []
})

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken();

  const admin = TokenService.getRoles().indexOf("ITSAdmin") >= 0;
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdminRole);
  
  const requiresEditorRole = to.matched.some(record => record.meta.requiresEditorRole);
  let inEditorRole = RoleService.inEditorRole();

  // Redirect to the correct home page if you're logged in or not
  if (to.name === 'home' && loggedIn) {
    return next({
      path:'/Home'
    });
  } else if (to.name === 'homeLoggedIn' && !loggedIn) {
    return next({
      path:'/'
    });
  }

  if ( (requiresAdmin && !admin) || (requiresEditorRole && !inEditorRole)) {
    return next({
      path:'/'
    });
  } else if (!isPublic && !loggedIn) {
    return next({
      path:'/Login'
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/')
  }

  next();
})
export default router;
